import React from 'react';
import { FileText, Download, Share2 } from 'lucide-react';
import { materiaisAPI } from '../../lib/api';

export const MATERIAIS = [
  {
    slug: 'resumo-cipe',
    titulo: 'Resumo da pesquisa',
    subtitulo: 'Quanto se paga por um plantão de cirurgia pediátrica no Brasil',
    descricao: 'Os principais números em 15 páginas: medianas por regime, duração, tipo de hospital, região e produção.',
    meta: '15 páginas · PDF · 0,5 MB',
    href: '/downloads/plantoes-cipe-resumo-apex.pdf',
    arquivo: 'Plantoes-Cirurgia-Pediatrica-Resumo-Apex.pdf',
  },
  {
    slug: 'relatorio-cipe',
    titulo: 'Relatório completo',
    subtitulo: 'Remuneração de plantão em cirurgia pediátrica no Brasil — setembro 2026',
    descricao: 'Análise detalhada dos 118 plantões declarados por 102 cirurgiões: todos os cortes, gráficos, tabelas por estado e metodologia.',
    meta: '29 páginas · PDF · 0,6 MB',
    href: '/downloads/relatorio-completo-plantoes-cipe-apex-2026-set.pdf',
    arquivo: 'Relatorio-Plantoes-Cirurgia-Pediatrica-Apex-2026.pdf',
  },
];

const SHARE_TEXT = 'Quanto vale o seu plantão de cirurgia pediátrica? Compare com 118 plantões de 102 colegas e baixe o relatório completo: https://apexmedicalhub.com/cipe';

const MaterialCard = ({ m }) => (
  <article className="group flex flex-col rounded-2xl bg-white border border-slate-200 p-6 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200" data-testid={`material-card-${m.slug}`}>
    <div className="flex items-start gap-4">
      <div className="w-12 h-12 rounded-xl bg-primary-50 text-primary flex items-center justify-center flex-shrink-0">
        <FileText className="w-6 h-6" />
      </div>
      <div className="min-w-0">
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-secondary">{m.titulo}</p>
        <h3 className="mt-1 font-heading text-lg font-bold text-slate-900 leading-snug">{m.subtitulo}</h3>
      </div>
    </div>
    <p className="mt-4 text-sm text-slate-600 leading-relaxed flex-1">{m.descricao}</p>
    <div className="mt-5 flex items-center justify-between gap-3">
      <span className="text-xs text-slate-400" data-testid={`material-meta-${m.slug}`}>{m.meta}</span>
      <a
        href={m.href}
        download={m.arquivo}
        onClick={() => materiaisAPI.registrarDownload(m.slug).catch(() => {})}
        className="inline-flex items-center gap-2 rounded-full bg-primary hover:bg-primary-800 text-white text-sm font-semibold px-5 py-2.5 transition-colors"
        data-testid={`material-download-${m.slug}`}
      >
        <Download className="w-4 h-4" />
        Baixar PDF
      </a>
    </div>
  </article>
);

export const MateriaisCipe = () => (
  <section className="bg-[#f3f7fa] border-t border-slate-200" data-testid="materiais-cipe">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
      <div className="max-w-2xl">
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-secondary">Materiais para baixar</p>
        <h2 className="mt-2 font-heading text-2xl sm:text-3xl font-bold text-primary tracking-tight">Leve os números da pesquisa com você</h2>
        <p className="mt-3 text-base text-slate-600">
          Dois documentos gratuitos, em PDF, com os resultados completos da pesquisa nacional sobre remuneração de plantões em cirurgia pediátrica. Um clique e o arquivo é seu.
        </p>
      </div>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
        {MATERIAIS.map((m) => <MaterialCard key={m.slug} m={m} />)}
      </div>
      <div className="mt-8 flex flex-wrap items-center gap-4">
        <a
          href={`https://wa.me/?text=${encodeURIComponent(SHARE_TEXT)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full border border-secondary text-secondary hover:bg-secondary hover:text-white text-sm font-semibold px-5 py-2.5 transition-colors"
          data-testid="materiais-compartilhar-whatsapp"
        >
          <Share2 className="w-4 h-4" />
          Compartilhar com colegas no WhatsApp
        </a>
        <span className="text-sm text-slate-500">Link curto: <span className="font-mono text-slate-700">apexmedicalhub.com/cipe</span></span>
      </div>
    </div>
  </section>
);
